import { createStore } from 'vuex';

export default createStore({
  state() {
    return {
      dynamicData: {}
    };
  },
  mutations: {
    SET_FIELD_VALUE(state, payload) {
        // In Vue 3, Sie können die reaktiven Daten direkt setzen
        state.dynamicData[payload.fieldKey] = payload.value;
    },
    CLEAR_ALL_DATA(state) {
        // Setzt das dynamicData-Objekt zurück
        state.dynamicData = {};
    }
  }
});